/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLineDashed = createReactComponent("outline", "line-dashed", "IconLineDashed", [["path", { "d": "M5 12h2", "key": "svg-0" }], ["path", { "d": "M17 12h2", "key": "svg-1" }], ["path", { "d": "M11 12h2", "key": "svg-2" }]]);

export { IconLineDashed as default };
//# sourceMappingURL=IconLineDashed.mjs.map
